// import { PropertyDetailsModel } from "ldp/common_platform/models/property_details";
// import { trackShare, trackshareEmailButtonClick } from "shared_critical/tracking/shared/shares";
// import { trackModalImpression } from 'shared_critical/tracking/shared/modal_impression';

MOVE.FeedbackModal = (function (MOVE) {
  var feedbackModal, feedbackThankyouModal, FeedbackForm, professionLookup, aboutLookup, specificLookup;
  feedbackModal         = '#feedbackModal';
  FeedbackForm          = '#feedbackForm';
  feedbackThankyouModal = '#feedbackThankYouModal';

  var init = function (target) {
    $(target).modal();
    if (target == feedbackModal){
      setFeedbackVariables();
      setFeedbackValidations();
      formInitialization();
      submitForm(FeedbackForm);  
    }
  };

  var setFeedbackVariables = function() {
    $('.feedback-non-spinner').show();
    $('.feedback-spinner').hide();

    professionLookup  = [ 'Home Buyer', 'Home Seller', 'Home Buyer & Seller', 'Real Estate Agent', 'Real Estate Broker', 'Renter', 'Landlord/Owner', 'Investor', 'Lender/Title Officer', 'Other' ];
    aboutLookup       = [ 'Property', 'Experience', 'Search', 'Selling a Property', 'Find a Realtor', 'My Account', 'Mortgage', 'News & Insights' ];
    specificLookup    = {
      'Property': ['Neighborhood', 'Schools', 'Property History', 'Property Detail', 'Home Value', 'Photos', 'Open Houses', 'Request Showing', 'Flood', 'Crime', 'Monthly Payment', 'Map', 'Other'],
      'Experience': ['Suggestion', 'Technical Issue', 'Performance', 'Kudos', 'Agent/Professional', 'Other'],
      'Search': ['Maps', 'New Filter Request', 'Filter Results', 'Neighborhoods', 'Keyword Search', 'Recommended Homes', 'Other'],
      'Selling a Property': ['Home Value Estimate', 'For Sale By Owner', 'Seller\'s Marketplace'],
      'Find a Realtor': ['Listings', 'Photo', 'Profile Details', 'Ratings & Reviews', 'Recommendations', 'Search', 'Other'],
      'My Account': ['Login', 'Seller Report', 'Saved Homes', 'Saved Searches', 'Professional Login', 'Hidden Homes', 'Notifications', 'Other'],
      'Mortgage': ['Calculator', 'Other'],
      'News & Insights': ['Positive Feedback', 'Article Suggestion', 'Guides', 'Housing Trends', 'Insights', 'Real Estate News', 'Other']
    };
  };

  var setFeedbackValidations = function(){
    $.validator.addMethod('isFeedbackProfession', function(value) {
        professionLookup.includes(value);
        return true;
      },
      $.validator.messages.profession
    );

    $.validator.addMethod('isFeedbackAbout', function(value) {
        aboutLookup.includes(value);
        return true;
      },
      $.validator.messages.about
    );

    $.validator.addMethod('isFeedbackSpecific', function(value) {
        if ($('#about').val() && aboutLookup.includes($('#about').val())) {
          if ($('#specific').val() && specificLookup[$('#about').val()].includes($('#specific').val())) {
            return true;
          }
        } else {
          return true;
        }
      },
      $.validator.messages.specific
    );

    $.validator.addMethod(
      'isFeedbackCommentHasUrl',
      function(value) {
        let regexPattern = /(\b(?:(?:https?|ftps?):\/\/|www\.)[-a-zA-Z0-9+&@#\/%?=~_|!:,.;]*[-a-zA-Z0-9+&@#\/%=~_|])|([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+)/g;
        return (regexPattern.test(value.toLocaleLowerCase())) ? false : true;
      },
      $.validator.messages.isFeedbackCommentHasUrl
    );
  };

  var submitForm = function(form){
    var feedbackValidator = $(form).validate({
      debug: true,
      rules: {
        'profession': { required: true, isFeedbackProfession: true },
        "email":      { email: true, required: true, pattern:/^.+@.+\..+$/ },
        "name":       { required: true, pattern: /^[a-zA-Z- ']{0,25}$/ },
        'about':      { required: true, isFeedbackAbout: true },
        'specific':   { required: false, isFeedbackSpecific: true },
        "comment":    { required: true, isFeedbackCommentHasUrl: true }
      },
      messages: {
        "profession": {
          required:               "This field cannot be left blank.",
          isFeedbackProfession:   "Please select valid"
        },
        "email": {
          required: "Please enter your email",
          email:    "Please enter a valid email",
          pattern:  "Please enter a valid email"
        },
        "name": {
          required: "Please enter your full name",
          pattern:  "Please enter a valid name. (Max 25 char. Special characters limited to hyphens & spaces)"
        },
        "about": {
          required:         "This field cannot be left blank.",
          isFeedbackAbout:  "Please select valid"
        },
        "specific": {
          isFeedbackSpecific: "This field cannot be left blank."
        },
        "comment": {
          required:                "This field cannot be left blank.",
          isFeedbackCommentHasUrl: "Your message can't contain any URL."
        }
      },
      onfocusout : function(e) {
        if(e.id =="name"){e.value = e.value.trim();}
      },
      errorPlacement: function(error, element) {
        error.insertAfter(element);
      },
      submitHandler: function(form) {
        $('.feedback-non-spinner').hide();
        $('.feedback-spinner').show();

        $('<input>').attr({ type: 'hidden', name: 'feedback_form_flag', value: true }).appendTo($(form));
        $('<input>').attr({ type: 'hidden', name: 'user_agent', value: navigator.userAgent }).appendTo($(form));
        $('<input>').attr({ type: 'hidden', name: 'location', value: document.location.href }).appendTo($(form));
        $.ajax({ data: $(form).serialize(), url: form.action, type: 'POST' });
      }
    });

    // clearing validation messages from fields
    feedbackValidator.resetForm();
    
    // clearing error style from fields
    var erroredFormFields = $(FeedbackForm).find('.error')
    if (erroredFormFields.length > 0) {
      erroredFormFields.removeClass('error');
    }
  };

  var afterSubmit = function (status){
    if ($(feedbackModal).length) {
      console.log('feedback end');
      $(feedbackModal).modal('hide');
    }
    if(status === 'ok') {
      feedbackThankyou();
    }
    else {
      setTimeout(function () {
        console.log('feedback error');
        alert('Failed to submit feedback. Please try again.');
      }, 400);
    }
  };

  var feedbackThankyou = function() {
    if ($(feedbackThankyouModal).length) {
      $(feedbackThankyouModal).modal();
    } else {
      event.preventDefault();
      MOVE.FeedbackModal.fetchModal(feedbackThankyouModal);
    }
  };

  var formInitialization = function(){
    // form reset
    $(FeedbackForm).trigger('reset');
    $('#profession').prop('selectedIndex',0);
    $('#about').prop('selectedIndex',0);
    $('#specific').prop('selectedIndex',0);

    $('#profession option:eq(0)').attr('disabled', true);
    $('#about option:eq(0)').attr('disabled', true);
    $('#specific option:eq(0)').attr('disabled', true);

    $('#about').on('change', function() {
       var aboutSelected = $(this).val();
       var optionsPopulate = specificLookup[aboutSelected];
        $('#specific option:gt(0)').remove();
        $('#specific').attr('disabled', false);
       for (i = 0; i < optionsPopulate.length; i++) {
         $('#specific').append($("<option></option>").attr("value", optionsPopulate[i]).text(optionsPopulate[i]));
       }
    });
  };

  var fetchModal = function(target) {
    if (!window.modals) window.modals = [];
    if (window.modals.indexOf(target) >= 0) {
      return
    } else {
      window.modals.push(target);
    }
  
    var targetForModalFetch = target.replace(/#/, '');
    var data = $.extend(MOVE.DOMHelper.getUrlParams(), {target: targetForModalFetch});
  
    MOVE.ModalHelper.removeErrorModal();

    return $.post('/properties/modals', data)
      .done(function(data) {
        $('#modal-container').append(data.html);
        $(document).trigger('modalInserted');
        MOVE.FeedbackModal.init(target);
        if ($(target).find('.modal-actions > a.btn').length) {
          $(target).find('.modal-actions > a.btn').on('click', function() {
            $(target).modal('hide');
          });
        }
      })
      .fail(function() {
        MOVE.ModalHelper.showErrorTryAgainModal(target, undefined);
      });
  };
  
  var bindFeedbackLinkClick = function() {
    $(document).on('click', '#global-nav-feedback', function(event) {
      if ($(feedbackModal).length) {
        MOVE.FeedbackModal.init(feedbackModal);
      } else {
        event.preventDefault();
        MOVE.FeedbackModal.fetchModal(feedbackModal);
      }
    });       
  };

  MOVE.FeedbackModal = {
    init:                   init,
    afterSubmit:            afterSubmit,
    fetchModal:             fetchModal,
    bindFeedbackLinkClick:  bindFeedbackLinkClick
  }

  return MOVE.FeedbackModal;

})(MOVE || {});

MOVE.FeedbackModal.bindFeedbackLinkClick();



// WEBPACK FOOTER //
// ./shared_critical/feedback.js